import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgQAb({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10H2V12C2 6.477 6.477 2 12 2zm0 2a8 8 0 00-8 8v8h8a8 8 0 000-16zm0 3a5 5 0 014.31 7.537l-.137.219.534.533a1 1 0 01-1.32 1.499l-.094-.084-.534-.533A5 5 0 1112 7zm0 2a3 3 0 101.293 5.707 1 1 0 011.32-1.498l.094.083A3 3 0 0012 9z"
        fill={color}
      />
    </svg>
  )
}

export default SvgQAb
